import pistaAvatar1 from "../assets/bg/pista-avatar-1.png";

const PISTA_AVATARS = [pistaAvatar1];

/**
 * Devuelve la URL (bundler) de uno de los avatares del modal de pista al azar.
 * Usar en cada apertura de modal (no cachear en módulo) para variar entre intentos.
 */
export function getRandomPistaAvatar() {
	return PISTA_AVATARS[Math.floor(Math.random() * PISTA_AVATARS.length)];
}
